import { HostAPIEditorX } from './HostAPIEditorX';
export class HostAPIStudio extends HostAPIEditorX {
    constructor() {
        super(...arguments);
        this.getExternalPanelsPrivateAPI = async () => {
            const externalPanelsPrivateAPI = await this.platformApiMethods.editor.getExternalPanelsPrivateAPI?.();
            return externalPanelsPrivateAPI;
        };
    }
}
//# sourceMappingURL=HostAPIStudio.js.map